export default function countDecimals(number) {

    if (Math.floor(number.valueOf()) === number.valueOf()) return 0

    var str = number.toString()
    if (str.indexOf('.') !== -1 && str.indexOf('-') !== -1) {
        return str.split('-')[1] || 0
    } else if (str.indexOf('.') !== -1) {
        return str.split('.')[1].length || 0
    }
    return str.split('-')[1] || 0
}